export default {
  enabled: process.env.VUE_APP_FRESH_RELEVANCE_ENABLED === 'true',
  scriptUrl: process.env.VUE_APP_FRESH_RELEVANCE_SCRIPT_URL,
  pixelUrl: process.env.VUE_APP_FRESH_RELEVANCE_PIXEL_URL,
};

